/**
 * swiper 轮播
 */

export default {
    init: (isMobile) => {
        if (isMobile) {
            new Swiper('.swiper-container', {
                direction: 'horizontal',
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true
                // },
                loop: true,
                // autoplay: {
                //     delay: 3000
                // },
            })
        }
        var mySwiper = new Swiper('.home-banner', {
            direction: 'horizontal',
            navigation: isMobile ? {} : {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            loop: true,
            autoplay: {
                delay: 3000
            },
        })
    }
}



// WEBPACK FOOTER //
// ./src/pages/index/swiper.js